/**
 * Global
 * ------
 */

// auto-open child menus
var delay = 250;
var timeout = false;
function autoActive() {
    if ($w.width() >= site.breakpoints.lg) {
        $('.auto-active').addClass(site.ac);
    } else {
        $('.auto-active').removeClass(site.ac);
    }
}
// wait for resize to be done before calling autoActive again
$w.on('resize', function () {
    // clear the timeout
    clearTimeout(timeout);
    // start timing for event "completion"
    timeout = setTimeout(autoActive, delay);
});
autoActive();

$('#site-menu-open').on('click', function (e) {
    e.preventDefault();
    $b.addClass('site-menu-open');
});
$('#site-menu-close').on('click', function (e) {
    e.preventDefault();
    $b.removeClass('site-menu-open');
});

$('.entry-content').fitVids();

$('#site-menu-close').on('click', function (e) {
    e.preventDefault();
    $('.level-2, .level-1-item, .level-2-item').removeClass(site.ac);

});
$('.level-2-back').on('click', function (e) {
    e.preventDefault();
    $('.level-2, .level-1-item').removeClass(site.ac);
});
$('.level-3-back').on('click', function (e) {
    e.preventDefault();
    $('.level-2-item').removeClass(site.ac);
});

var closeLevel3 = function () {
    $('.level-2.active, .level-2 .active').removeClass(site.ac);
};

$b.on('click', '.level-2-toggle', function (e) {
    e.preventDefault();
    var $parent = $(this).closest('li');
    closeLevel3();
    if ($parent.hasClass(site.ac)) {
        // closing all
        $parent.removeClass(site.ac);
    } else {
        // changing tab
        $('#site-nav li').removeClass(site.ac);
        $parent.addClass(site.ac);
        $($(this).attr('href')).addClass(site.ac);
    }
});

$b.on('click', '.level-3-toggle', function (e) {
    e.preventDefault();
    var $parent = $(this).closest('li');
    if ($parent.hasClass(site.ac)) {
        $parent.removeClass(site.ac); // closing all
    } else {
        $('.level-2 li').removeClass(site.ac);
        $parent.addClass(site.ac); // changing tab
    }
});

$b.on('click', '.is-dropdown-toggle', function (e) {
    e.preventDefault();
    $(this).closest('.dropdown').toggleClass(site.ac);
});

$b.on('keyup', function (e) {
    // keyCode is getting deprecated use key instead when supported, which makes this messy
    evt = e || window.event;
    var isEscape = false;
    if ("key" in evt) {
        isEscape = (evt.key == "Escape" || evt.key == "Esc");
    } else {
        isEscape = (evt.keyCode == 27);
    }
    if (isEscape) {
        closeLevel3();
        $('#site-header .' + site.ac).removeClass(site.ac);
        $('.modal').removeClass(site.ac);
        $('#calc-popover').removeClass(site.ac);
        $b.removeClass('modal-open');
    }
});


$b.on('click', '.is-modal-trigger', function (e) {
    e.preventDefault();
    var $target = $($(this).attr('href'));
    if (!$target.length) {
        $target = $($(this).data('target'));
    }
    $target.addClass(site.ac);
    $target.find('h2').focus();
    if ($(this).hasClass('zoom')) {
        $('#zoom-image').attr('src', $(this).data('img-src'));
    }
    $b.addClass('modal-open');
});
$b.on('click', '.is-modal-close', function (e) {
    e.preventDefault();
    $('.modal').removeClass(site.ac);
    $('#calc-popover').removeClass(site.ac);
    $b.removeClass('modal-open');
});

var $sliderItems = $('.payouts-slider .items');
$sliderItems.slick({
    arrows: true,
    dots: true,
    prevArrow: '<button type="button" class="btn slick-prev">' + siteIcons.previousSmall + '<span class="sr-only">Previous</span></button>',
    nextArrow: '<button type="button" class="btn slick-next">' + siteIcons.nextSmall + '<span class="sr-only">Next</span></button>'
});

// the whole row is clickable with a mouse, but we need to use the toggle for keyboard access
$b.on('click', '.r-excerpt, .row-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).closest('.r').toggleClass(site.ac);
});
$b.on('click', '.expand-all-trigger', function (e) {
    e.preventDefault();
    var $races = $(this).closest('.row').find('.races .r');
    $(this).toggleClass(site.ac);
    if ($(this).hasClass(site.ac)) {
        $(this).text($(this).data('active-text'));
        $races.addClass(site.ac);
    } else {
        $(this).text($(this).data('inactive-text'));
        $races.removeClass(site.ac);
    }
});

/*
Page Navs
*/
var $pageNav = $('#page-nav');
if ($pageNav.length) {
    if (!$('[data-nav-label]').length) {
        $pageNav.hide(); // it's possible to have the nav element without any nav-label elements later on in the page (like in the dashboard)
    } else {
        $('[data-nav-label]').each(function () {
            $pageNav.find('ul').append('<li><a href="#' + $(this).attr('id') + '">' + $(this).data('nav-label') + '</a></li>');
        });
    }
}

/*
Enhanced WP button styles
*/
$('.wp-block-button').each(function () {
    var $link = $(this).find('.wp-block-button__link');
    if ($(this).hasClass('is-style-star')) {
        $link.prepend(window.siteIcons.star);
    }
    if ($(this).hasClass('is-style-user')) {
        $link.prepend(window.siteIcons.user);
    }
});

/*
Sign up form
*/
function is_valid_email_address(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
}
// var $message = $('#newsletter-form-message');
// $('#newsletter-form-submit').on('click', function(e){
//   e.preventDefault();
//   $message.removeClass('has-error has-success').text('');
//   var email = $("#newsletter-form-email").val();
//   if (!is_valid_email_address(email)) {
//     $message.addClass('has-error').text("Please enter a valid email address.");
//     return false;
//   }
//   if (!email) {
//     $message.addClass('has-error').text("Please enter your email.");
//     return false;
//   }
//   $('#newsletter-form').addClass('working');
//   $.ajax({
//     method: 'post',
//     url: "/wp-admin/admin-ajax.php",
//     data: {
//     'action': 'rd_form_opt_in',
//     'email': email
//     },
//     success: function(data){
//       var data = JSON.parse(data);
//       if (data.errors) {
//         $message.addClass('has-error').text("Sorry, there was an error subscribing you.");
//       } else {
//         $message.addClass('has-success').text("All set! Please check your email for a welcome message.");
//         $("#newsletter-form-email").val('');
//       }
//       $('#newsletter-form').removeClass('working');
//     }
//   });
// });

$('.opt-in-form').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
    var $message = $(this).closest('section').find('.opt-in-message');
    var $field = $form.find('input');
    var email = $field.val();
    $message.removeClass('has-error has-success').text('');
    if (!is_valid_email_address(email)) {
        $message.addClass('has-error').text("Please enter a valid email address.");
        return false;
    }
    if (!email) {
        $message.addClass('has-error').text("Please enter your email.");
        return false;
    }
    $form.addClass('working');
    $.ajax({
        method: 'post',
        url: "/wp-admin/admin-ajax.php",
        data: {
            'action': 'rd_form_opt_in',
            'email': email
        },
        success: function (data) {
            var data = JSON.parse(data);
            if (data.errors) {
                $message.addClass('has-error').text("Sorry, there was an error subscribing you.");
            } else {
                $message.addClass('has-success').text("All set! Please check your email for a welcome message.");
                $field.val('');
            }
            $form.removeClass('working');
        }
    });
});


$(document).ready(function () {
    $('.message-carousel .items').slick({
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: '<button type="button" class="btn slick-prev">' + siteIcons.previousSmall + '<span class="sr-only">Previous</span></button>',
        nextArrow: '<button type="button" class="btn slick-next">' + siteIcons.nextSmall + '<span class="sr-only">Next</span></button>'
    });
});
